
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bookafreehomedemo",
      function () {
        return require("private-next-pages/bookafreehomedemo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bookafreehomedemo"])
      });
    }
  